import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const GuideIntegrationInfo = (props: Props) => {
    return (
        <S_GuideIntegrationInfo className={props.className}>
            Guide Integration Info
        </S_GuideIntegrationInfo>
    );
};

const S_GuideIntegrationInfo = styled.div``;
